/**
 * Fonds de carte vectoriels servis par VersaTiles : gratuits, sans clé d'API,
 * et dérivés d'OpenStreetMap.
 *
 * Le premier essai empilait un voile sombre sur des tuiles raster OSM. Le
 * résultat était terne : désaturer une image ne fabrique pas une carte de nuit,
 * cela efface juste la hiérarchie — l'eau, les parcs et les rues finissaient de
 * la même couleur. Les tuiles vectorielles portent chaque objet séparément, donc
 * un style peut assombrir le fond *et* garder l'eau bleue et les axes lisibles.
 *
 * Les deux styles viennent du même fournisseur : mêmes géométries, mêmes
 * placements d'étiquettes, même serveur de glyphes. Basculer de l'un à l'autre
 * ne donne pas l'impression de changer d'application.
 */
export const BASEMAPS = {
  night: { url: "https://tiles.versatiles.org/assets/styles/eclipse/style.json" },
  day: { url: "https://tiles.versatiles.org/assets/styles/colorful/style.json" },
} as const;

export type BasemapId = keyof typeof BASEMAPS;

export const BASEMAP_IDS: readonly BasemapId[] = ["night", "day"];

export const isBasemapId = (value: unknown): value is BasemapId =>
  typeof value === "string" && Object.hasOwn(BASEMAPS, value);

/** Hôte à autoriser dans la CSP (tuiles, glyphes, sprites). Voir docker/Caddyfile. */
export const BASEMAP_HOST = "https://tiles.versatiles.org";

/**
 * Le style porte déjà l'attribution OpenStreetMap ; le fournisseur de tuiles
 * mérite la sienne.
 */
export const BASEMAP_ATTRIBUTION =
  '<a href="https://versatiles.org" target="_blank" rel="noreferrer">VersaTiles</a>';
